import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RequestStatus } from "common/enums/requestStatus";
import IProject from "common/interfaces/IProject";
import { fetch } from "core/Api";

interface IExploreState {
  posts: IProject[];
  selected: IProject | undefined;
  status: RequestStatus;
  error: any;
}

const initialState: IExploreState = {
  posts: [],
  selected: undefined,
  status: RequestStatus.IDLE,
  error: null,
};

export const fetchProjects = createAsyncThunk("projects", async () => {
  try {
    const data = await fetch("/projects");
    return data;
  } catch (e: any) {
    return console.error(e.message);
  }
});

export const fetchProjectById = createAsyncThunk(
  "projectById",
  async (projectId: string) => {
    try {
      const data = await fetch(`/projects/${projectId}`);
      return data;
    } catch (e: any) {
      return console.error(e.message);
    }
  }
);

export const exploreSlice = createSlice({
  name: "explore",
  initialState,
  reducers: {
    resetProjects: (state) => {
      state = initialState;
    },
    removeApplicant: (state, action) => {
      state.selected?.roles?.forEach((role) => {
        if (role._id === action.payload.roleId) {
          role.applicants = role.applicants.filter(
            (applicant) => applicant._id !== action.payload.applicantId
          );
          return;
        }
      });
    },
    assignUser: (state, action) => {
      state.selected?.roles?.forEach((role) => {
        if (role._id === action.payload.roleId) {
          role.userId = action.payload.applicant;
          role.applicants = role.applicants.filter(
            (applicant) => applicant._id !== action.payload.applicant._id
          );
          return;
        }
      });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProjects.pending, (state, action) => {
      state.status = RequestStatus.PENDING;
    });
    builder.addCase(fetchProjects.fulfilled, (state, action) => {
      state.status = RequestStatus.SUCCEEDED;
      // remove the type any when the api is ready
      state.posts = action.payload as any;
    });
    builder.addCase(fetchProjects.rejected, (state, action) => {
      state.status = RequestStatus.FAILED;
      state.error = action.error.message;
    });

    builder.addCase(fetchProjectById.pending, (state, action) => {
      state.status = RequestStatus.PENDING;
    });
    builder.addCase(fetchProjectById.fulfilled, (state, action) => {
      state.status = RequestStatus.SUCCEEDED;
      // remove the type any when the api is ready
      state.selected = action.payload as any;
    });
    builder.addCase(fetchProjectById.rejected, (state, action) => {
      state.status = RequestStatus.FAILED;
      state.error = action.error.message;
    });
  },
});

export const { resetProjects, removeApplicant, assignUser } =
  exploreSlice.actions;

export default exploreSlice.reducer;
